import { render, staticRenderFns } from "./EditAssemblyAreaModal.vue?vue&type=template&id=e4158fd4&"
import script from "./EditAssemblyAreaModal.vue?vue&type=script&lang=js&"
export * from "./EditAssemblyAreaModal.vue?vue&type=script&lang=js&"
import style0 from "./EditAssemblyAreaModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports